// extracted by mini-css-extract-plugin
export default {"container":"ConfirmMultifactorAuthForm_container__+BDCY","input":"ConfirmMultifactorAuthForm_input__ce3gI","button":"ConfirmMultifactorAuthForm_button__slgy6"};